import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FollowUpCard from "../../../components/Dashboard/FollowUpCard";
import { useState, useEffect } from "react";
import {
  getFollowups,
  deleteFollowup,
  getFollowupsLC,
  deleteFollowupLC,
} from "../../../services/operations/followupAPI";
import icon from "../../../asstes/boticon.png";
import virtuallabicon from "../../../asstes/virtual-lab.png";
import softskillicon from "../../../asstes/softskills.png";
import habitsicon from "../../../asstes/habits.png";
import {
  getAssignments,
  updateAssignmentStatus,
} from "../../../services/operations/assignmentAPI";
import AssignmentCard from "../../../components/Dashboard/Student/AssignmentCard";
import { useTranslation } from "react-i18next";

// Header Component
const Header = ({ name }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-blue-800 text-white p-6 rounded-xl shadow-lg">
      <h1 className="text-2xl sm:text-3xl font-bold">
        {t("studentDashboard.hello")}, {name}!
      </h1>
      <p className="mt-1 text-blue-200">
        {t("studentDashboard.welcomeMessage")}
      </p>
    </div>
  );
};

// Main Dashboard Page Component
export default function Student() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.profile);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [followUps, setFollowUps] = useState([]);
  const [followUpLc, setFollowUpLc] = useState([]);
  const [assignments, setAssignments] = useState([]);

  const handleFollowupClick = (followup) => {
    navigate(`/dashboard/student/chatbot/${followup.conversation_id}`);
    dispatch(deleteFollowup(followup._id));
  };

  const handleFollowupLcClick = (followup) => {
    navigate(`/dashboard/student/chatbot/${followup.conversation_id}`);
    dispatch(deleteFollowupLC(followup._id));
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAssignments()();
      setAssignments(data?.data || []);
    };
    fetchData();
  }, []);

  const handleStatusChange = async (id, newStatus) => {
    await updateAssignmentStatus(id, newStatus)();
    const data = await getAssignments()();
    setAssignments(data?.data || []);
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await getFollowups()();
      if (data?.messages && Array.isArray(data.messages)) {
        setFollowUps(data.messages);
      } else {
        setFollowUps([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getFollowupsLC()();
      if (data?.messages && Array.isArray(data.messages)) {
        setFollowUpLc(data.messages);
      } else {
        setFollowUpLc([]);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8 bg-[#f7fafd]">
      <div className="max-w-7xl mx-auto">
        <Header name={user.name} />

        <div className="mt-6">
          <h2 className="text-xl font-bold text-gray-700 mb-4">
            {t("studentDashboard.myClassrooms")}
          </h2>

          {/* --- Chatbot Navigation Card/Button --- */}
          <div
            onClick={() => navigate("/dashboard/student/chatbot")}
            className="cursor-pointer bg-gradient-to-r from-blue-600 to-blue-800  mb-8 text-white rounded-2xl p-6 shadow-lg hover:scale-105 transition-all duration-300"
          >
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div className="mb-4 sm:mb-0">
                <h4 className="text-xl font-bold">
                  {t("studentDashboard.launchAITutor")}
                </h4>
                <p className="text-sm text-blue-100 mt-1">
                  {t("studentDashboard.launchDesc")}
                </p>
              </div>
              <div className="sm:ml-6 flex-shrink-0">
                <img
                  src={icon}
                  alt="icon"
                  className="h-12 w-12 rounded-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* --- Virtual Lab Navigation Card/Button --- */}
          <div
            onClick={() => navigate("/dashboard/student/virtual-lab")}
            className="cursor-pointer bg-gradient-to-r from-indigo-700 to-blue-900 mb-8 text-white rounded-2xl p-6 shadow-lg hover:scale-105 transition-all duration-300"
          >
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div className="mb-4 sm:mb-0">
                <h4 className="text-xl font-bold">{t("studentDashboard.launchVirtualLab")}</h4>
                <p className="text-sm text-blue-100 mt-1">
                  {t("studentDashboard.labDesc")}
                </p>
              </div>
              <div className="sm:ml-6 flex-shrink-0">
                <img
                  src={virtuallabicon}
                  alt="lab icon"
                  className="h-12 w-12 rounded-full object-cover bg-white p-2"
                />
              </div>
            </div>
          </div>

          {/* --- Soft Development Skills Navigation Card/Button --- */}
          <div
            onClick={() => navigate("/dashboard/student/soft-skills")}
            className="cursor-pointer bg-gradient-to-r from-blue-700 to-indigo-800 mb-8 text-white rounded-2xl p-6 shadow-lg hover:scale-105 transition-all duration-300"
          >
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div className="mb-4 sm:mb-0">
                <h4 className="text-xl font-bold">
                  {t("studentDashboard.soft&CommunicationSkills")}
                </h4>
                <p className="text-sm text-blue-100 mt-1">
                  {t("studentDashboard.softSkillsDesc")}
                </p>
              </div>
              <div className="sm:ml-6 flex-shrink-0">
                <img
                  src={softskillicon}
                  alt="soft skills icon"
                  className="h-12 w-12 rounded-full object-cover bg-white p-2"
                />
              </div>
            </div>
          </div>

          {/* --- Food Habits and Mobile phone addiction --- */}
          <div
            onClick={() => navigate("/dashboard/student/habits")}
            className="cursor-pointer bg-gradient-to-r from-indigo-700 to-blue-900 mb-8 text-white rounded-2xl p-6 shadow-lg hover:scale-105 transition-all duration-300"
          >
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div className="mb-4 sm:mb-0">
                <h4 className="text-xl font-bold">{t("studentDashboard.foodHabitsAndPhoneAddiction")}</h4>
                <p className="text-sm text-blue-100 mt-1">
                 {t("studentDashboard.habitsDesc")}
                </p>
              </div>
              <div className="sm:ml-6 flex-shrink-0">
                <img
                  src={habitsicon}
                  alt="lab icon"
                  className="h-12 w-12 rounded-full object-cover bg-white p-2"
                />
              </div>
            </div>
          </div>

          {/* --- Follow-ups --- */}
          <div className="mb-8">
            <h3 className="text-lg font-bold text-gray-700 mb-3">
              📌 {t("studentDashboard.followups")}
            </h3>
            <div className="space-y-3 max-h-64 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-yellow-400 scrollbar-track-yellow-100 rounded-lg overflow-x-hidden">
              {followUps.length === 0 && followUpLc.length === 0 ? (
                <p className="text-gray-500 text-sm">
                  {t("studentDashboard.noFollowups")}
                </p>
              ) : (
                <>
                  {followUps.map((item) => (
                    <div
                      key={item._id}
                      onClick={() => handleFollowupClick(item)}
                      className="cursor-pointer hover:brightness-95 hover:shadow-lg transition-all duration-200"
                    >
                      <FollowUpCard
                        message={item.message || item.current_topic}
                        summary={item.summary || item.suggestion_text}
                        topic={item.topic || item.current_subject}
                      />
                    </div>
                  ))}

                  {followUpLc.map((item) => (
                    <div
                      key={item._id}
                      onClick={() => handleFollowupLcClick(item)}
                      className="cursor-pointer hover:brightness-95 hover:shadow-lg transition-all duration-200"
                    >
                      <FollowUpCard
                        message={item.current_topic}
                        summary={item.suggestion_text}
                        topic={item.current_subject}
                      />
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>

          {/* --- Assignments --- */}
          <div className="mb-8">
            <h3 className="text-lg font-bold text-gray-700 mb-3">
              {t("studentDashboard.assignments")}
            </h3>
            <div className="space-y-3 max-h-64 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-yellow-400 scrollbar-track-yellow-100 rounded-lg overflow-x-hidden">
              {assignments.length === 0 ? (
                <p className="text-gray-500 text-sm">
                  {t("studentDashboard.noAssignments")}
                </p>
              ) : (
                assignments.map((item) => (
                  <div
                    key={item._id}
                    className="cursor-pointer hover:brightness-95 hover:shadow-lg transition-all duration-200"
                  >
                    <AssignmentCard
                      assignment={item}
                      onStatusChange={handleStatusChange}
                    />
                  </div>
                ))
              )}
            </div>
          </div>

          {/* --- Description --- */}
          <div className="bg-white rounded-2xl shadow-md p-6 border border-blue-100">
            <h3 className=" text-2xl font-bold text-blue-800 mb-4">
              {t("studentDashboard.title")}
            </h3>
            <ul className="list-disc list-inside text-gray-700 space-y-3 text-[15px] leading-relaxed">
              <li>{t("studentDashboard.point1")}</li>
              <li>{t("studentDashboard.point2")}</li>
              <li>{t("studentDashboard.point3")}</li>
              <li>{t("studentDashboard.point4")}</li>
              <li>{t("studentDashboard.point5")}</li>
              <li>{t("studentDashboard.point6")}</li>
              <li>{t("studentDashboard.point7")}</li>
              <li>{t("studentDashboard.point8")}</li>
              <li>{t("studentDashboard.point9")}</li>
              <li>{t("studentDashboard.point10")}</li>
              <li>{t("studentDashboard.point11")}</li>
              <li>{t("studentDashboard.point12")}</li>
              <li>{t("studentDashboard.point13")}</li>
              <li>{t("studentDashboard.point14")}</li>
            </ul>
            <p className="mt-4 text-sm text-gray-500">
              {t("studentDashboard.footerNote")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
